import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './Modal.module.scss';

const modalRoot = document.getElementById('modal-root');
export default class Modal extends Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        modalRoot.removeChild(this.el);
    }

    render() {
        if (!this.props.isOpen) return null;

        let modalClass;

        switch (this.props.size) {
            case `large`:
                modalClass = 'modalLarge';
                break;
            case `medium`:
                modalClass = 'modalMedium';
                break;
            case `small`:
                modalClass = 'modalSmall';
                break;
            default:
                modalClass = 'modalMedium';
        }

        return ReactDOM.createPortal(
            <div className={styles.wrapper}>

                <div className={styles.modalWrapper}>
                    <div className={styles[modalClass]}>
                        <button onClick={this.props.onClose} className={styles.close}>
                            <div className={styles.closeIcon}>×</div>
                        </button>
                        <div className={styles.body}>{this.props.children}</div>
                    </div>
                </div>
                <div className={styles.overlay} onClick={this.props.onClose} />
            </div>,
            this.el
        );
    }
}

Modal.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
    size: PropTypes.oneOf(['large', 'medium', 'small'])
};
